/* src/app/modules/shared/components/no-data-icon/no-data-icon.component.scss */
.no-findings {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  scale: 0.8;
  opacity: 0.9;
  gap: 0.5rem;
}
/*# sourceMappingURL=no-data-icon.component.css.map */
